import { Directive, HostListener, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPhoneFormatter]'
})
export class PhoneFormatterDirective implements OnInit {
  constructor(private ngControl: NgControl) {}

  ngOnInit(): void {
    const currentValue = this.ngControl.control?.value;
    if (currentValue) {
      this.ngControl.control?.setValue(this.formatPhoneNumber(currentValue), { emitEvent: false });
    }
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const digits = value.replace(/\D/g, ''); // Remove non-digit characters
    const formatted = this.formatPhoneNumber(digits);
    this.ngControl.control?.setValue(formatted, { emitEvent: false });
  }

  private formatPhoneNumber(value: string): string {
    const match = value.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (!match) {
      return value;
    }
    const [, areaCode, prefix, lineNumber] = match;
    let formatted = '';
    if (areaCode) {
      formatted = `(${areaCode}`;
    }
    if (areaCode && prefix) {
      formatted += `) ${prefix}`;
    }
    if (areaCode && prefix && lineNumber) {
      formatted += `-${lineNumber}`;
    }
    return formatted;
  }
}
